import React from "react";
import "./App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "sonner";
import RequireAdmin from "./components/RequireAdmin";

import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import PrintSheet from "./pages/PrintSheet";
import PrinterSheet from "./pages/PrinterSheet";
import BrandQR from "./pages/BrandQR";
import StickerPrintSheet from "./pages/StickerPrintSheet";
import CheckpointAdmin from "./pages/CheckpointAdmin";
import CheckpointMintsAdmin from "./pages/CheckpointMintsAdmin";

function Guard({ children }) {
  return <RequireAdmin>{children}</RequireAdmin>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<Guard><AdminDashboard /></Guard>} />
            <Route path="/admin/print" element={<Guard><PrintSheet /></Guard>} />
            <Route path="/admin/print-cards" element={<Guard><PrinterSheet /></Guard>} />
            <Route path="/admin/brand-qr" element={<Guard><BrandQR /></Guard>} />
            <Route path="/admin/print-stickers/:batchName" element={<Guard><StickerPrintSheet /></Guard>} />
            <Route path="/cc/admin" element={<Guard><CheckpointAdmin /></Guard>} />
            <Route path="/cc/admin/mints" element={<Guard><CheckpointMintsAdmin /></Guard>} />
            <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
          </Routes>
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
